/**
 * Layout constants shared between the in-drawer terminal and its
 * fixed-position side panel. Centralising the values prevents the
 * two from drifting — the side panel grows by `SIDEBAR_WIDTH` when
 * the sidebar opens, which must match the width that
 * `BlockTerminalTab` renders the sidebar at, or the chat pane
 * shrinks (or the panel ends up with a gap).
 */

/** Width of the in-drawer sessions sidebar (matches Paradex's 280px). */
export const SIDEBAR_WIDTH = 280;

/**
 * Minimum width of the chat pane in the side-panel mount. The panel
 * grows when the sidebar opens so the chat pane never gets squished.
 */
export const CHAT_PANE_WIDTH = 420;
